var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"assets"},[_c('empty',{attrs:{"type":"clock","title":"Time is money and money is good, right?"}},[_c('div',{staticClass:"badge badge--warning"},[_vm._v("Coming Soon!")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }